module.exports = __webpack_public_path__ + "img/cucc.ad950622.jpg";